module.exports = __webpack_public_path__ + "static/img/kefu.dd814260.png";